import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { StreamInfo, useRoomStore } from '../../../../stores/room';
import Avatar from '../../../common/Avatar.vue';
import AudioIcon from '../../../common/AudioIcon.vue';
import SvgIcon from '../../../common/base/SvgIcon.vue';
import UserIcon from '../../../common/icons/UserIcon.vue';
import { useI18n } from '../../../../locales';
import { TUIRole, TUIVideoStreamType } from '@tencentcloud/tuiroom-engine-js';
import { isInnerScene } from '../../../../utils/constants';
import ScreenOpenIcon from '../../../common/icons/ScreenOpenIcon.vue';
import { isPC, isMobile } from '../../../../utils/environment';
import { storeToRefs } from 'pinia';
import LoadingIcon from '../../../common/icons/LoadingIcon.vue';

interface Props {
  streamInfo: StreamInfo;
  enlargeDomId?: string;
  changeLargeStream?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    streamInfo: null,
    enlargeDomId: null,
    changeLargeStream: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  streamInfo: StreamInfo;
  enlargeDomId?: string;
  changeLargeStream?: boolean;
};

const roomStore = useRoomStore();

const { t } = useI18n();


const { userVolumeObj } = storeToRefs(roomStore);
const userInfo = computed(() => roomStore.userInfoObj[props.streamInfo.userId]);

const displayName = computed(() => {
  if (isInnerScene) {
    return `${roomStore.getDisplayName(props.streamInfo.userId)} | ${props.streamInfo.userId}`;
  }
  return roomStore.getDisplayName(props.streamInfo.userId);
});

const showMasterIcon = computed(() => {
  const { userId, streamType } = props.streamInfo;
  return (
    userId === roomStore.masterUserId &&
    streamType === TUIVideoStreamType.kCameraStream
  );
});

const showAdminIcon = computed(() => {
  const { userId, streamType } = props.streamInfo;
  return (
    roomStore.getUserRole(userId) === TUIRole.kAdministrator &&
    streamType === TUIVideoStreamType.kCameraStream
  );
});

const showVoiceBorder = computed(() => {
  if (isPC) {
    return false;
  }
  return (
    props.streamInfo.hasAudioStream &&
    userVolumeObj.value[props.streamInfo.userId] !== 0
  );
});

const showIcon = computed(() => showMasterIcon.value || showAdminIcon.value);
const isScreenStream = computed(
  () => props.streamInfo.streamType === TUIVideoStreamType.kScreenStream
);

return { __sfc: true,roomStore, t, props, userVolumeObj, userInfo, displayName, showMasterIcon, showAdminIcon, showVoiceBorder, showIcon, isScreenStream, Avatar, AudioIcon, SvgIcon, UserIcon, ScreenOpenIcon, isPC, isMobile, LoadingIcon }
}

})